/**
 * 헤더 쪽지 뱃지 + SSE 클라이언트 (lda header.html 로직 이식 — Alpine.data 컴포넌트화).
 *
 * - EventSource('/note/api/sse/connect') 연결, 'unread-count' 이벤트로 뱃지 갱신.
 * - 2단계 처리: 첫 이벤트(접속 직후 초기 동기화)=뱃지만 + 세션 1회 안내 토스트(ldk_note_alert_shown),
 *   이후 이벤트=카운트 증가 시에만 "새로운 쪽지" 토스트(새로고침마다 알림 뜨는 것 방지).
 * - onerror: CLOSED 일 때만 지수 백오프 수동 재연결(2s→…→최대 30s, 10회),
 *   CONNECTING 은 브라우저 자동 재연결에 위임. 5분 서버 타임아웃 후 자동 재수립.
 * - '@note-read' window 이벤트 → REST 재조회(뱃지 보조 동기화 — 쪽지함 페이지 열람 시).
 * - inboxUrl: 토스트 링크 목적지. 데스크톱 헤더는 기본값(/note/inbox), 모바일 앱바는 noteBadge('/m/note/inbox').
 *   ※ 페이지당 1인스턴스만 — 서버 SseEmitterManager 가 유저당 emitter 를 교체하므로 2개면 서로 끊는다.
 */
export default (inboxUrl = '/note/inbox') => ({
    unreadCount: 0,
    inboxUrl,
    _es: null,
    _first: true,
    _attempts: 0,

    init() {
        this.connect();
        window.addEventListener('note-read', () => this.refresh());
    },

    connect() {
        try { this._es?.close(); } catch (e) { /* 무시 */ }

        const es = new EventSource('/note/api/sse/connect');
        this._es = es;

        es.addEventListener('unread-count', (e) => {
            let count = 0;
            try { count = JSON.parse(e.data).unreadCount || 0; } catch (err) { return; }
            const prev = this.unreadCount;
            this.unreadCount = count;

            if (this._first) {
                this._first = false;
                if (count > 0 && !sessionStorage.getItem('ldk_note_alert_shown')) {
                    sessionStorage.setItem('ldk_note_alert_shown', '1');
                    this.$dispatch('show-toast', {
                        type: 'info', title: '쪽지함',
                        message: '확인하지 않은 쪽지가 ' + count + '개 있습니다.',
                        link: { href: this.inboxUrl }
                    });
                }
            } else if (count > prev) {
                this.$dispatch('show-toast', {
                    type: 'info', title: '쪽지', message: '새로운 쪽지가 도착했습니다.',
                    link: { href: this.inboxUrl }
                });
            }
        });

        es.addEventListener('heartbeat', () => { /* keep-alive — 무시 */ });

        es.onopen = () => { this._attempts = 0; };

        es.onerror = () => {
            if (es.readyState !== EventSource.CLOSED) return; // CONNECTING = 브라우저 자동 재연결
            if (this._attempts >= 10) return;                 // 포기(다음 페이지 이동 시 재시작)
            const delay = Math.min(1000 * Math.pow(2, this._attempts), 30000);
            this._attempts++;
            setTimeout(() => this.connect(), delay);
        };
    },

    async refresh() {
        try {
            const res = await fetch('/note/api/unread-count');
            const json = await res.json();
            if (json.success) this.unreadCount = json.data.unreadCount;
        } catch (e) { /* SSE 가 주 경로 — 조용히 무시 */ }
    }
});
